import { isNullOrUndefined } from './misc';

export const compareCaseIgnored = (value1, value2) => {
  if (isNullOrUndefined(value1) || isNullOrUndefined(value2)) return false;
  return value1.toLowerCase() === value2.toLowerCase();
};

export const isEmptyString = (value) => {
  return isNullOrUndefined(value) || value === '';
};
